import React from 'react'

import './Error.scss'

const Error = ({ children }) => <div className="layout__error">{children}</div>

export default Error
